import { render, staticRenderFns } from "./ItemRenderer.vue?vue&type=template&id=cf46121c&"
import script from "./ItemRenderer.vue?vue&type=script&lang=js&"
export * from "./ItemRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ItemRenderer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf46121c')) {
      api.createRecord('cf46121c', component.options)
    } else {
      api.reload('cf46121c', component.options)
    }
    module.hot.accept("./ItemRenderer.vue?vue&type=template&id=cf46121c&", function () {
      api.rerender('cf46121c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/v2/schema/ItemRenderer.vue"
export default component.exports